(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-storefront"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cc-carousel'))customElements.define('cc-carousel',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.cc-slides');const buttons=[...this.querySelectorAll('[data-slide]')];buttons.forEach((button,i)=>button.addEventListener('click',()=>track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));let pending=false;track.addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{const i=Math.round(track.scrollLeft/track.clientWidth);buttons.forEach((b,n)=>n===i?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current'));pending=false})},{passive:true});track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();track.scrollBy({left:track.clientWidth*(e.key==='ArrowRight'?1:-1),behavior:'smooth'})}})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
